import { useWeb3React } from '@web3-react/core';
import useWeb3 from '../useWeb3';
import { getFactoryContract, getPairAddressContract, getToken, getwETHContract } from '../../utils/contractHelpers';
import { gemsFactoryContract, wETHContract } from '../../utils/Enviroment';
import BigNumber from 'bignumber.js';
import { gemsRouterContract } from '../../utils/Enviroment'

export const useBuyPoolHook = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();
    const FEE_PERCENTAGE = 0.3;

    const buyTradeTransaction = async (contractAddress, tradeAmount, time) => {
        try {
            const factoryContract = await getFactoryContract(gemsFactoryContract, web3);
            const routerContract = await getToken(gemsRouterContract, web3);

            let gasPrice = await web3.eth.getGasPrice();
            gasPrice = parseInt(gasPrice);

            const feeData = await web3.eth.getFeeHistory(1, 'latest', [25, 50, 75]);
            const baseFee = new BigNumber(feeData.baseFeePerGas[0]); // Base Fee from last block
            const priorityFee = new BigNumber(web3.utils.toWei("0.1", "gwei")); // 0.1 Gwei priority fee

            // Ensure maxFeePerGas is at least baseFee + priorityFee
            const maxFeePerGas = BigNumber.maximum(baseFee.multipliedBy(2), priorityFee.plus(baseFee));
            const maxPriorityFeePerGas = priorityFee;

            const address = web3.utils.toChecksumAddress(contractAddress)
            const pairAddress = await factoryContract?.methods?.getPair(address).call();
            if (!pairAddress) throw new Error("Pair address not found");

            const pairContract = await getPairAddressContract(pairAddress, web3);

            const reserves = await pairContract?.methods?.getReserves().call();
            const reserveWETH = reserves?.reserveWETH;
            const rockReserves = reserves?.reserveRock;
            const feeAmountInWei = web3.utils.toWei(tradeAmount, "ether");
            const amountOut = await routerContract?.methods
                ?.getAmountOutWithFee(feeAmountInWei, reserveWETH, rockReserves)
                .call();
            const amountOutBN = new BigNumber(amountOut);
            const feeAmountBN = amountOutBN.multipliedBy(FEE_PERCENTAGE).dividedBy(100);
            const amountOutAfterDeduction = amountOutBN.minus(feeAmountBN).integerValue(BigNumber.ROUND_FLOOR);
            const getNumber = (amountOutAfterDeduction)?.toFixed(0)
            const buyTrade = await routerContract?.methods
                ?.buyWithETH(getNumber, true, address, account, time)
                .send({
                    from: account,
                    gasPrice: gasPrice,
                    maxFeePerGas,
                    maxPriorityFeePerGas,
                    value: feeAmountInWei
                });
            return buyTrade;
        } catch (error) {
            console.error("Error executing buy trade transaction:", error);
            throw new Error(error.message || "Transaction failed");
        }
    };

    const getTotalMintedGems = async (contractAddress) => {
        const address = web3.utils.toChecksumAddress(contractAddress)
        const factoryContract = await getFactoryContract(gemsFactoryContract, web3);
        const pairAddress = await factoryContract?.methods?.getPair(address).call();
        if (!pairAddress) throw new Error("Pair address not found");
        const ethContract = await getwETHContract(wETHContract, web3);
        const balanceOf = await ethContract?.methods?.balanceOf(pairAddress).call();
        return { balanceOf };
    }

    return { buyTradeTransaction, getTotalMintedGems };
};

export default useBuyPoolHook;